var tokens = require("./tokens.json"); module.exports = tokens; // eslint-disable-line